import React from "react"
import "./styles.scss"

const Index = ({data}) => {
     let inputElement = null;
    inputElement = (
        <>
           <div className="account-wrapper">
           <h1 className="title">Create your free account</h1>
           <p className="subtext">Already have an account? <a href="/signin">sign in</a>
           </p>
           </div>
    </>
    );
    return <>{inputElement}</>;
}

export default Index;
